import React, { useEffect, useState } from 'react';

import { isEmpty } from 'lodash';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { getCoreViewId, getCoreViewName } from '../Navigation/NavigationHelper';

import CoreClientTable from './Client/CoreClientTable';
import CoreSiteTable from './Site/CoreSiteTable';
import CoreViewSelector from '../../../components/CoreViewSelector';
import ClientActionMenu from './Client/ClientActionMenu';
import SiteActionMenu from './Site/SiteActionMenu';
import CoreEquipmentTable from './Equipment/CoreEquipmentTable';
import EquipmentActionMenu from './Equipment/EquipmentActionMenu';
import CoreSystemTable from './System/CoreSystemTable';
import SystemActionMenu from './System/SystemActionMenu';
import ContactsTable from '../Contacts/ContactsTable';
import ContactsTableActionMenu from '../Contacts/ContactsTableActionMenu';
import { setPageTitle } from '../../../helpers/auth';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';
import PreviewWeatherDataModal from '../Modals/PreviewWeatherDataModal';

import queryString from 'query-string';

import * as ConfigurationActions from '../../../actions/configurationActions';
import * as ContactActions from '../../../actions/contactActions';
import * as DashboardActions from '../../../actions/dashboardActions';

import * as classes from './TableContainer.module.css';

const TableContainer = ({
    activeNavCompany,
    activeNavClient,
    activeNavSite,
    bulkDeleteContact,
    fetchAllConfigurations,
    fetchClientContacts,
    fetchSiteContacts,
    history,
    setWorkBookMode,
    userId,
    workbookModeEnabled,
    ...props
}) => {
    const _contactExport = React.useRef(null);

    const [view, setView] = useState();
    const [searchTerm, setSearchTerm] = useState('');
    const [refreshTab, setRefreshTab] = useState('');
    const [contactTableSelectState, setContactTableSelectState] = useState({});
    const [previewWeatherDataModalOpen, setPreviewWeatherDataModalOpen] = useState(false);

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        const childId = queryValues.childId;
        const selectedView = getCoreViewName(childId);
        setView(selectedView);

    }, [queryValues.childId]);

    useEffect(() => {
        const init = async () => {
            await fetchAllConfigurations(userId);
        };

        if (activeNavCompany.id) init();
    }, [activeNavCompany]);

    useEffect(() => {
        if (view) {
            let names = view.split(' ');
            let appName = 'K2A Core';
            let entityName = '';

            if (names.length === 2 ) {
                if (names[0] === 'Company') {
                    entityName = activeNavCompany.name;
                } else if (names[0] === 'Client') {
                    entityName = activeNavClient.name;
                } else if (names[0] === 'Site') {
                    entityName = activeNavSite.name;
                }

                if (entityName) {
                    setPageTitle(`${appName} - ${entityName}`, names[1]);
                } else {
                    setPageTitle(`${appName} - ${names[0]}`, names[1]);
                }
            }
        }
    }, [activeNavCompany, activeNavClient, activeNavSite, view]);

    const handleChangeView = view => {
        const { pathname } = history.location;
        const selectedId = getCoreViewId(view);

        const queryVals = queryString.parse(history.location.search);
        queryVals.childId = selectedId;
        
        const queryValuesString = queryString.stringify(queryVals);

        if (selectedId) history.push(`${pathname}?${queryValuesString}`);
        setView(view);
        setSearchTerm('');
    };

    const handleCreateContact = () => {
        const queryValues = queryString.parse(history.location.search);
        const queryValuesString = queryString.stringify(queryValues);
        history.push(`/v2/dashboard/contacts?${queryValuesString}`);
    };

    const handleDeleteContacts = async () => {
        if (isEmpty(contactTableSelectState)) return;

        let filteredContactState = { ...contactTableSelectState };

        for (var key in filteredContactState) {
            if (filteredContactState[key] === false) {
                delete filteredContactState[key];
            }
        }

        const ids = Object.keys(filteredContactState);

        if (ids) {
            await bulkDeleteContact(ids);

            if (view === 'Site Contact') {
                await fetchSiteContacts(activeNavClient.id, activeNavSite.id);
            } else {
                await fetchClientContacts(activeNavClient.id);
            }

            setContactTableSelectState({});
        }
    };

    const refreshGrid = () => {
        setRefreshTab(view);
    };

    const handleContactExport = () => {
        const options = _contactExport.current.workbookOptions();
        const rows = options.sheets[0].rows;

        rows.forEach((row, index) => {
            if (row.type === 'data') {
                const nameCell = row.cells[0];
                const primaryCell = row.cells[3];
                const smsCell = row.cells[4];
                const numbers = _contactExport.current.props.data[index - 1].userAssignmentPhones;

                const name = _contactExport.current.props.data[index - 1].userName;
                const primary = numbers.find(item => item.isPrimary === true);
                const sms = numbers.find(item => item.isSMS === true);

                nameCell.value = name.FirstName + ' ' + name.LastName;
                primaryCell.value = primary ? primary.phoneNumber.number : null;
                smsCell.value = sms ? sms.phoneNumber.number : null;
            }
        });

        if (_contactExport.current !== null) {
            _contactExport.current.save(options);
        }
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    return (
        <div className={classes.TableContainer}>
            <div className={classes.SelectorContainer}>
                <CoreViewSelector
                    view={view}
                    handleChangeView={handleChangeView}
                />
            </div>
            <div className={classes.SearchContainer} />
            <div className={classes.TotalsContainer}>
                <BobWorkbookModeButton
                    handleWorkbookMode={handleWorkbookMode}
                    workbookMode={workbookModeEnabled}
                />
            </div>
            <div
                className={classes.RefreshContainer}
                aria-hidden="true"
                role="button"
                tabIndex={0}
                onClick={refreshGrid}
            >
                <span className="material-icons-outlined">refresh</span>
            </div>
            <div className={classes.ActionsContainer}>
                <span className={classes.ActionButton}>
                    {
                        view === 'Company Client' ?
                            <ClientActionMenu />
                            :
                            null
                    }
                    {
                        view === 'Company Site' || view === 'Client Site' ?
                            <SiteActionMenu />
                            :
                            null
                    }
                    {
                        view === 'Company Equipment' || view === 'Client Equipment' || view === 'Site Equipment' ?
                            <EquipmentActionMenu
                                activeNavSite={activeNavSite}
                                handlePreviewWeatherData={() => setPreviewWeatherDataModalOpen(true)}
                            />
                            :
                            null
                    }
                    {
                        view === 'Site System' ?
                            <SystemActionMenu
                                activeNavSite={activeNavSite}
                                handlePreviewWeatherData={() => setPreviewWeatherDataModalOpen(true)}
                            />
                            :
                            null
                    }
                    {
                        view === 'Client Contact' || view === 'Site Contact' ?
                            <ContactsTableActionMenu
                                handleContactExport={handleContactExport}
                                handleCreateContact={handleCreateContact}
                                handleDeleteContacts={handleDeleteContacts}
                            />
                            :
                            null
                    }
                </span>
            </div>
            <div className={classes.TablePanel}>
                {
                    view === 'Company Client' ?
                        <CoreClientTable
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                            searchTerm={searchTerm}
                            view={view}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        :
                        null
                }
                {
                    view === 'Company Site' || view === 'Client Site' ?
                        <CoreSiteTable
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                            searchTerm={searchTerm}
                            view={view}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        :
                        null
                }
                {
                    view === 'Company Equipment' || view === 'Client Equipment' || view === 'Site Equipment' ?
                        <CoreEquipmentTable
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                            searchTerm={searchTerm}
                            view={view}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        :
                        null
                }
                {
                    view === 'Site System' ?
                        <CoreSystemTable
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                            searchTerm={searchTerm}
                            view={view}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        :
                        null
                }
                {
                    view === 'Site Contact' || view === 'Client Contact' ?
                        <ContactsTable
                            _contactExport={_contactExport}
                            contactTableSelectState={contactTableSelectState}
                            setContactTableSelectState={setContactTableSelectState}
                            refreshTab={refreshTab}
                            setRefreshTab={(tab) => setRefreshTab(tab)}
                            view={view}
                            workbookModeEnabled={workbookModeEnabled}
                        />
                        :
                        null
                }
            </div>
            {
                previewWeatherDataModalOpen ?
                    <PreviewWeatherDataModal
                        site={activeNavSite}
                        onClose={() => setPreviewWeatherDataModalOpen(false)}
                    />
                    :
                    null
            }
        </div>
    );
};

const mapStateToProps = state => {
    return {
        activeNavCompany:    state.bob.activeNavCompany,
        activeNavClient:     state.bob.activeNavClient,
        activeNavSite:       state.bob.activeNavSite,
        workbookModeEnabled: state.dashboard.workbookModeEnabled,
        userId:              state.currentUser.id
    };
};


const mapDispatchToProps = {
    ...ContactActions,
    ...ConfigurationActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TableContainer));
